const select = () => {
  // *register-myob.shiftpayments.com.au
  // *register.shiftpayments.com.au
  if (window.location.hostname.indexOf('shiftpayments') > -1) {
    return 'GTM-P5XJP5R';
  }

  // *register-admin.getcapital.com.au
  // *register.getcapital.com.au
  return 'GTM-KMDHXJQ';
};

export default {
  select,
};
